var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0042 13.1838C16.2048 12.9838 16.2054 12.6591 16.0055 12.4584L10.3997 6.83262C10.1792 6.61135 9.82087 6.61135 9.60038 6.83262L3.99458 12.4584C3.79464 12.6591 3.79522 12.9838 3.99587 13.1838C4.19652 13.3837 4.52126 13.3831 4.7212 13.1825L10 7.8848L15.2789 13.1825C15.4788 13.3831 15.8035 13.3837 16.0042 13.1838Z",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1316 13.3293C15.4127 13.6113 15.8692 13.6127 16.1513 13.3317C16.4335 13.0506 16.4341 12.5934 16.1529 12.3112L10.5475 6.68538C10.2456 6.38245 9.75483 6.38255 9.45291 6.68538L3.84663 12.3112C3.56557 12.5934 3.56695 13.0506 3.84907 13.3317C4.13125 13.6125 4.58772 13.6113 4.86877 13.3293L9.99979 8.18115L15.1316 13.3293ZM15.8567 13.0363C15.7376 13.1548 15.5449 13.1545 15.4262 13.0355L10.1479 7.73763C10.1088 7.6984 10.0552 7.6766 9.99979 7.6766C9.94453 7.67666 9.89152 7.69851 9.85249 7.73763L4.57336 13.0355C4.45463 13.1545 4.26195 13.1549 4.14286 13.0363C4.02378 12.9176 4.02353 12.725 4.14204 12.6058L9.74832 6.97998C9.88739 6.84045 10.113 6.84043 10.2521 6.97998L15.8575 12.6058C15.9763 12.7249 15.9759 12.9176 15.8567 13.0363Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.744892c0b6e59a5f54b6fc1ee1127c5e.svg";
export { ForwardRef as ReactComponent };